import momentTz from 'moment-timezone';
import moment from '../moment';
import i18n from 'i18n';

export const getDateAsTimeFromNow = (date: Maybe<Date>): string => {
  return moment(date).fromNow();
};

export const getFormattedDateWithFullMonthName = (date: Date | string): string =>
  moment(date).format('LL');

export const getTimezoneOffset = (): number => new Date().getTimezoneOffset() * 60;

export const getDateWithTimezone = (
  date?: Nullable<string>,
  timezone?: string,
  format?: string
) => {
  if (date) {
    return timezone
      ? momentTz(date)
          .tz(timezone)
          .format(format || 'YYYY-MM-DD')
      : momentTz(date).format(format || 'YYYY-MM-DD');
  }

  return null;
};

export const getLastActive = (iso: string): string => {
  const date = new Date(iso);

  const hours = moment().diff(iso, 'hours');
  const days = moment().diff(iso, 'days');

  if (!hours) {
    return 'Recently';
  }
  if (!days) {
    return `${hours} ${i18n.t('hour', { count: hours }).toLowerCase()} ago`;
  }
  if (days <= 7) {
    return `${days} ${i18n.t('day', { count: days }).toLowerCase()} ago`;
  }

  return moment(date).format('MMMM D');
};

export const formatExpires = (iso: string): string => {
  const date = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
  }).format(new Date(iso));

  return moment(date).format('MMMM D');
};
